export const createPmtilesUrl = (url: string) => {
  return `pmtiles://${url}`
}
